<!-- Spinner -->

<!-- Content -->
@if (question && question.solutions !== undefined && trainingResult && trainingResult.answer !== undefined) {
  @if (question.solutions !== null && trainingResult.answer !== null && question.solutions.length === trainingResult.answer.length) {
    <!-- Header -->
    <medsurf-quiz-question-header [index]="((trainingSharedFacade.quizActive$ | async) ? undefined : question.customEnumeration) || (((trainingSharedFacade.selectedQuestionIndex$(question.id) | async) || index) + 1).toString()"
      [checkedAndCorrect]="trainingResult.showFeedback && isCorrect()"
      [questionType]="question.type">
    </medsurf-quiz-question-header>
    <form name="form"
      class="mdsf-quiz-form">
      <!-- Question Text -->
      <medsurf-text [text]="question.content"></medsurf-text>
      <!-- Choices -->
      @if ((trainingSharedFacade.typedQuestionChoicesOrder$ | async); as typedQuestionChoicesOrder) {
        <div class="mb-4 flex flex-column">
          @for (choice of (trainingSharedFacade.choicesByIds$(question.choices || []) | async | sortBy_shared: 'asc': 'order'); track choice; let j = $index) {
            @if ({ index: typedQuestionChoicesOrder[question.id].indexOf(choice.id) || 0 }; as order) {
            <div class="choice"
              [ngStyle]="{'order': order.index}"
              [attr.data-order]="choice.order"
              [class.choice-light]="!showRequired && trainingResult.showFeedback === false && !(order.index % 2)"
              [class.choice-error]="trainingResult.showFeedback && question.solutions[j] !== trainingResult.answer[j]"
              [class.choice-correct]="trainingResult.showFeedback && question.solutions[j] === trainingResult.answer[j]"
              [class.choice-not-answered]="showRequired && passItemRequired(j)"
              [class.no-hover]="trainingResult.showFeedback">
              <div class="btn-group btn-group-toggle"
                data-toggle="buttons"
                ngbRadioGroup
                [name]="question.id + '-' + j"
                [class.not-answered]="trainingResult.showFeedback && passItemRequired(j)">
                <label ngbButtonLabel
                  class="radio-custom"
                  [class.radio-custom-black]="trainingResult.answer[j] === '1' || (question.solutions[j].toString() === '1' && (menuSharedFacade.showPrintForAuthor$ | async))"
                  [class.radio-custom-error]="trainingResult.showFeedback && trainingResult.answer[j] === '1' && question.solutions[j].toString() !== trainingResult.answer[j]">
                  <input ngbButton
                    type="radio"
                    name="choices{{question.order}}{{j}}"
                    [value]="'1'"
                    (click)="onClick(j, '1')"
                    [checked]="trainingResult.answer[j] === '1'">
                  <i class="fa fa-check"></i>
                  @if (trainingResult.showFeedback && trainingResult.answer[j] === '1' && question.solutions[j].toString() !== trainingResult.answer[j]) {
                    <i class="fal fa-times cross"
                    ></i>
                  }
                </label>
                <label ngbButtonLabel
                  class="radio-custom"
                  [class.radio-custom-black]="trainingResult.answer[j] === '0' || (question.solutions[j].toString() === '0' && (menuSharedFacade.showPrintForAuthor$ | async))"
                  [class.radio-custom-error]="trainingResult.showFeedback && trainingResult.answer[j] === '0' && question.solutions[j].toString() !== trainingResult.answer[j]">
                  <input ngbButton
                    type="radio"
                    name="choices{{question.order}}{{j}}"
                    [value]="'0'"
                    (click)="onClick(j, '0')"
                    [checked]="trainingResult.answer[j] === '0'">
                  <i class="fa fa-times"></i>
                  @if (trainingResult.showFeedback && trainingResult.answer[j] === '0' && question.solutions[j].toString() !== trainingResult.answer[j]) {
                    <i
                    class="fal fa-times cross"></i>
                  }
                </label>
              </div>
              <div class="choice-label ml-3">
                <label class="choice-label-character">{{ trainingSharedFacade.helperListCharacter(question.numberingType, order.index) }}</label>
                <label class="choice-label-text">
                  <medsurf-text [text]="choice.label"></medsurf-text>
                </label>
              </div>
            </div>
            }
          }
        </div>
      }
      <!-- Explanation -->
      @if (question.explanation && (trainingResult.showExplanation || (menuSharedFacade.showPrintForAuthor$ | async))) {
        <div class="form-control-explanation mt-2"
          >
          <strong>{{ 'explanation' | translate }}</strong>
          <medsurf-text [text]="question.explanation"></medsurf-text>
        </div>
      }
      <!-- Footer -->
      @if ((menuSharedFacade.showPrint$ | async) === false && (question.solutions || []).length >= (question.choices || []).length) {
        <medsurf-quiz-question-footer #footer
          class="mt-2"
          [question]="question"
          [trainingResult]="trainingResult"
          [isCorrect]="isCorrect"
          [passRequired]="passRequired"
          [(showRequired)]="showRequired"
          [ngStyle]="{'order': 100}">
        </medsurf-quiz-question-footer>
      }
    </form>
  }
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
